import { toast } from '../design-system/index.js'

// Honest feedback for controls whose backend doesn't exist yet: the control is
// present (so the screen matches its design and the affordance is discoverable),
// but acting on it says so plainly instead of failing silently. Swap each call
// site for the real action as its endpoint lands.
export function comingSoon(feature: string): void {
  toast.info('Disponible pronto', {
    description: `${feature} llegará en una próxima versión.`,
  })
}
